import React from 'react'
import styles from './HeroSection.module.css'
import heroLogo from "../../assets/heroLogo.svg"

const HeroSection = ({ ytStats, instagramStats }) => {

    const formatNumber = (num) => {
        if (num === null || num === undefined || num === '') return '--';

        const number = Number(num);

        if (isNaN(number)) return '--';

        if (number >= 1e9) {
            return `${(number / 1e9).toFixed(1)} billion`;
        }

        if (number >= 1e6) {
            return `${(number / 1e6).toFixed(2)} million`;
        }

        if (number >= 1e3) {
            return `${(number / 1e3).toFixed(1)}K`;
        }

        return number.toString();
    };


    return (
        <div className={styles.hero}>
            <img
                className={styles.heroLogo}
                src={heroLogo}
                alt="FasBeam"
            />

            <h1 className={styles.heroTitle}>
                India’s Leading Automobile Content Creator
            </h1>

            <div className={styles.heroMain}>
                <span className={styles.heroText}>
                    With over{' '}
                    <strong>
                        {formatNumber(ytStats?.subscribers)}
                    </strong>{' '}
                    subscribers on YouTube, a community of{' '}
                    <strong>
                        {formatNumber(instagramStats?.followers)}
                    </strong>{' '}
                    followers on Instagram, and more than{' '}
                    <strong>
                        {formatNumber(ytStats?.views)}
                    </strong>{' '}
                    video views, FasBeam has become one of the biggest
                    names in the Indian automobile space.

                    {' '}From{' '}
                    <strong>
                        {formatNumber(ytStats?.videoCount)}
                    </strong>{' '}
                    car and bike reviews to real-life driving experiences,
                    FasBeam is more than just content — it’s a passionate
                    community for every car and bike enthusiast.
                </span>
            </div>
        </div>
    )
}

export default HeroSection